<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="loadReport">
                  <v-row class="px-2 py-2">
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        v-model="filters.supplier_id"
                        :items="supplierList"
                        :item-title="item => item.supplier_name"
                        item-value="id"
                        label="Filter by Supplier (Optional)"
                        density="compact"
                        prepend-inner-icon="mdi-account-outline"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        clearable
                        hide-details
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-select
                        v-model="filters.status"
                        :items="statusOptions"
                        label="Filter by Status (Optional)"
                        density="compact"
                        prepend-inner-icon="mdi-filter"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        clearable
                        hide-details
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="filters.from_date"
                        label="From Date (Optional)"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        hide-details
                        clearable
                        :max="filters.to_date"
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="filters.to_date"
                        label="To Date (Optional)"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        hide-details
                        clearable
                        :min="filters.from_date"
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                LC Register Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        v-if="reportData.length > 0"
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right">
                      <v-chip
                        v-if="reportData.length > 0"
                        color="primary"
                        variant="tonal"
                        size="small"
                      >
                        Total: {{ reportData.length }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="reportData"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.lc_no="{ item }">
                    <strong>{{ item.lc_no }}</strong>
                  </template>

                  <template v-slot:item.code="{ item }">
                    {{ item.code || "-" }}
                  </template>

                  <template v-slot:item.lc_open_date="{ item }">
                    {{ formatDateView(item.lc_open_date) }}
                  </template>

                  <template v-slot:item.expiry_date="{ item }">
                    {{ formatDateView(item.expiry_date) }}
                  </template>

                  <template v-slot:item.supplier="{ item }">
                    {{ item.supplier?.supplier_name || "N/A" }}
                  </template>

                  <template v-slot:item.bank="{ item }">
                    {{ item.bank?.name || "N/A" }}
                  </template>

                  <template v-slot:item.lc_type="{ item }">
                    {{ item.lc_type?.name || item.lcType?.name || "N/A" }}
                  </template>

                  <template v-slot:item.lc_amount="{ item }">
                    {{ $numberFormat(item.lc_amount) }}
                  </template>

                  <template v-slot:item.pi_count="{ item }">
                    {{ item.pis?.length || 0 }}
                  </template>

                  <template v-slot:item.pi_total="{ item }">
                    {{ $numberFormat(item.pis?.reduce((sum, pi) => sum + (parseFloat(pi.total_amount) || 0), 0) || 0) }}
                  </template>

                  <template v-slot:item.lc_status="{ item }">
                    <v-chip
                      :color="getLcStatusColor(item.lc_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.lc_status || "Draft" }}
                    </v-chip>
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center pa-4">
                      <v-icon size="48" color="grey">mdi-database-search</v-icon>
                      <p class="text-grey mt-2">No LC data found</p>
                      <p class="text-caption text-grey">Click Search to load report data</p>
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import Axios from "axios";
import { getLcImportRegisterReport } from "@/store/api";
import formattedDate from '@/plugins/dateFormatter';


export default {
  name: "LcImportRegisterReport",
  methods: {
    formatDateView,
  },
  setup() {
    const store = useStore();
    const instance = getCurrentInstance();

    const panel = ref([0]);
    const panel1 = ref([0]);
    const loading = ref(false);
    const search = ref("");
    const reportData = ref([]);
    const filters = ref({
      supplier_id: null,
      status: null,
      from_date: null,
      to_date: null,
    });

    const statusOptions = [
      { title: "Draft", value: "Draft" },
      { title: "Open", value: "Open" },
      { title: "Amended", value: "Amended" },
      { title: "Shipped", value: "Shipped" },
      { title: "Document-Received", value: "Document-Received" },
      { title: "Cleared", value: "Cleared" },
      { title: "Closed", value: "Closed" },
      { title: "Cancelled", value: "Cancelled" },
    ];

    const headers = [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "LC No", key: "lc_no", align: "left", sortable: true },
      { title: "LC Code", key: "code", align: "left", sortable: true },
      { title: "LC Open Date", key: "lc_open_date", align: "left", sortable: true },
      { title: "Expiry Date", key: "expiry_date", align: "left", sortable: true },
      { title: "Supplier", key: "supplier", align: "left", sortable: false },
      { title: "Bank", key: "bank", align: "left", sortable: false },
      { title: "LC Type", key: "lc_type", align: "left", sortable: false },
      { title: "LC Amount", key: "lc_amount", align: "right", sortable: true },
      { title: "PI Count", key: "pi_count", align: "center", sortable: false },
      { title: "PI Total", key: "pi_total", align: "right", sortable: false },
      { title: "LC Status", align: "center", key: "lc_status", sortable: true },
    ];

    const supplierList = computed(() => {
      return store.getters.getSupplierList || [];
    });

    const getCurrentCompany = computed(() => {
      return store.getters.getCurrentCompany || {};
    });

    const getFileServerUrl = computed(() => {
      return store.getters.getFileServerUrl || "";
    });

    const loadReport = async () => {
      try {
        loading.value = true;
        const params = {};
        
        if (filters.value.supplier_id) {
          params.supplier_id = filters.value.supplier_id;
        }
        
        if (filters.value.status) {
          params.status = filters.value.status;
        }
        
        if (filters.value.from_date && filters.value.to_date) {
          params.from = filters.value.from_date;
          params.to = filters.value.to_date;
          params.from_date = formattedDate(filters.value.from_date);
          params.to_date = formattedDate(filters.value.to_date);
        }

        const response = await Axios.get(getLcImportRegisterReport, { params });
        reportData.value = response.data || [];
        
        if (reportData.value.length === 0) {
          toast.info("No LC data found for the selected criteria");
        } else {
          toast.success(`Loaded ${reportData.value.length} LC record(s)`);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load LC register report");
        reportData.value = [];
      } finally {
        loading.value = false;
      }
    };

    const getLcStatusColor = (status) => {
      const colors = {
        Draft: "grey",
        Open: "info",
        Amended: "warning",
        Shipped: "success",
        "Document-Received": "primary",
        Cleared: "success",
        Closed: "default",
        Cancelled: "error",
      };
      return colors[status] || "default";
    };

    const exportToCSV = () => {
      const items = reportData.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const data = [[
        "#SL",
        "LC No",
        "LC Code",
        "LC Open Date",
        "Expiry Date",
        "Supplier",
        "Bank",
        "LC Type",
        "LC Amount",
        "PI Count",
        "PI Total",
        "LC Status",
      ]];

      items.forEach((item, index) => {
        const piTotal =
          (item.pis || []).reduce(
            (sum, pi) => sum + (parseFloat(pi.total_amount) || 0),
            0
          ) || 0;

        data.push([
          index + 1,
          item.lc_no || "",
          item.code || "",
          formatDateView(item.lc_open_date),
          formatDateView(item.expiry_date),
          item.supplier?.supplier_name || "N/A",
          item.bank?.name || "N/A",
          item.lc_type?.name || item.lcType?.name || "N/A",
          item.lc_amount ?? 0,
          item.pis?.length || 0,
          piTotal,
          item.lc_status || "Draft",
        ]);
      });

      const proxy = instance?.proxy;
      if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
        proxy.$exportTableToCSV(
          data,
          "lc_import_register_report_" + proxy.$fileDate()
        );
      } else {
        toast.error("CSV export is not configured");
      }
    };

    const exportToExcel = () => {
      const items = reportData.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const data = [[
        "#SL",
        "LC No",
        "LC Code",
        "LC Open Date",
        "Expiry Date",
        "Supplier",
        "Bank",
        "LC Type",
        "LC Amount",
        "PI Count",
        "PI Total",
        "LC Status",
      ]];

      items.forEach((item, index) => {
        const piTotal =
          (item.pis || []).reduce(
            (sum, pi) => sum + (parseFloat(pi.total_amount) || 0),
            0
          ) || 0;

        data.push([
          index + 1,
          item.lc_no || "",
          item.code || "",
          formatDateView(item.lc_open_date),
          formatDateView(item.expiry_date),
          item.supplier?.supplier_name || "N/A",
          item.bank?.name || "N/A",
          item.lc_type?.name || item.lcType?.name || "N/A",
          item.lc_amount ?? 0,
          item.pis?.length || 0,
          piTotal,
          item.lc_status || "Draft",
        ]);
      });

      const proxy = instance?.proxy;
      if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
        proxy.$exportTableToExcel(
          data,
          "lc_import_register_report_" + proxy.$fileDate()
        );
      } else {
        toast.error("Excel export is not configured");
      }
    };

    const exportToPDF = async () => {
      const items = reportData.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const company = getCurrentCompany.value;
      const fileServerUrl = getFileServerUrl.value;

      let printWindow = window.open(
        "",
        "PRINT",
        `width=${screen.width}, height=${screen.height}, left=0, top=0`
      );

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
            <title>LC Import Register Report</title>
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">
            <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
            <style>
              body { font-family: 'Arimo', sans-serif; margin: 0px; }
              .invoice-header { display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #eee; padding-bottom:10px; }
              .invoice-header img { max-height: 70px; max-width: 150px; }
              .table th, .table td { border: 1px solid #000; padding: 8px; vertical-align: middle; font-size: 12px; }
              .table th { background-color: #f0f0f0; color: #333; }
              .text-end { text-align: right; }
              .text-center { text-align: center; }
              h4 { font-size: 20px; color: #333; }
              p { font-size: 14px; color: #555; margin: 2px 0; }
              strong { font-weight: bold; color: #333; }
              @page { margin: 0.5in; size: letter; }
              .logo-container { display:flex; align-items:center; }
              .logo-container img { margin-left: 10px; }
              .table { width: 100%; border-collapse: collapse; table-layout: auto; }
              thead { display: table-header-group; }
              .totals-row { page-break-inside: avoid; }
              .totals-row td { font-weight: bold; background-color: #f5f5f5 !important; }
            </style>
          </head>
          <body>
            <div class="container-fluid position-relative">
              <div class="invoice-header">
                <div>
                  <h4 class="text-uppercase">${company?.name || "Company Name"}</h4>
                  <p style="width:65%">${company?.address || ""}</p>
                  <p><i class="mdi mdi-phone-outline"></i> ${company?.mobile || ""}</p>
                  <p><i class="mdi mdi-email-outline"></i> ${company?.email || ""}</p>
                  ${company?.website ? `<p><i class="mdi mdi-web"></i> ${company.website}</p>` : ""}
                </div>
                <div class="logo-container">
                  ${
                    company?.logo_thumb
                      ? `<img src="${fileServerUrl}${company.logo_thumb}" alt="Logo" class="img-fluid">`
                      : ""
                  }
                </div>
              </div>
              <h4 class="text-center my-4"><strong>LC IMPORT REGISTER REPORT</strong></h4>
              <div class="row mb-3">
                <div class="col-sm-8">
                  ${
                    filters.value.from_date && filters.value.to_date
                      ? `<p><strong>Period:</strong> ${formatDateView(
                          filters.value.from_date
                        )} to ${formatDateView(filters.value.to_date)}</p>`
                      : ""
                  }
                  ${
                    filters.value.supplier_id
                      ? (() => {
                          const supplier = supplierList.value.find(
                            (s) => s.id === filters.value.supplier_id
                          );
                          return supplier
                            ? `<p><strong>Supplier:</strong> ${
                                supplier.supplier_name || ""
                              }</p>`
                            : "";
                        })()
                      : ""
                  }
                  ${
                    filters.value.status
                      ? `<p><strong>LC Status:</strong> ${filters.value.status}</p>`
                      : ""
                  }
                </div>
                <div class="col-sm-4 text-end">
                  <p><strong>Total Records:</strong> ${items.length}</p>
                </div>
              </div>
              <table class="table mt-4">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>LC No</th>
                    <th>LC Code</th>
                    <th>LC Open Date</th>
                    <th>Expiry Date</th>
                    <th>Supplier</th>
                    <th>Bank</th>
                    <th>LC Type</th>
                    <th class="text-end">LC Amount</th>
                    <th class="text-center">PI Count</th>
                    <th class="text-end">PI Total</th>
                    <th class="text-center">LC Status</th>
                  </tr>
                </thead>
                <tbody>
                  ${items
                    .map((item, index) => {
                      const piTotal =
                        (item.pis || []).reduce(
                          (sum, pi) => sum + (parseFloat(pi.total_amount) || 0),
                          0
                        ) || 0;

                      return `
                        <tr>
                          <td>${index + 1}</td>
                          <td>${item.lc_no || ""}</td>
                          <td>${item.code || ""}</td>
                          <td>${formatDateView(item.lc_open_date)}</td>
                          <td>${formatDateView(item.expiry_date)}</td>
                          <td>${item.supplier?.supplier_name || "N/A"}</td>
                          <td>${item.bank?.name || "N/A"}</td>
                          <td>${item.lc_type?.name || item.lcType?.name || "N/A"}</td>
                          <td class="text-end">${(item.lc_amount ?? 0).toLocaleString()}</td>
                          <td class="text-center">${item.pis?.length || 0}</td>
                          <td class="text-end">${piTotal.toLocaleString()}</td>
                          <td class="text-center">${item.lc_status || "Draft"}</td>
                        </tr>
                      `;
                    })
                    .join("")}
                </tbody>
              </table>
            </div>
          </body>
        </html>
      `);

      printWindow.moveTo(0, 0);
      printWindow.focus();
      await new Promise((resolve) => setTimeout(resolve, 500));
      printWindow.print();
      printWindow.close();
    };

    onMounted(async () => {
      // Load supplier list for filter dropdown
      // if (store.getters.getSupplierList.length === 0) {
        try {
          await store.dispatch("getSupplierList", {});
        } catch (error) {
          console.error("Failed to load supplier list:", error);
        }
      // }
    });

    return {
      panel,
      panel1,
      loading,
      search,
      reportData,
      filters,
      headers,
      supplierList,
      statusOptions,
      loadReport,
      getLcStatusColor,
      exportToCSV,
      exportToExcel,
      exportToPDF,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

